// extracted by mini-css-extract-plugin
module.exports = {"packs-page-container":"packs_packs-page-container__EIXmG","sale-ending":"packs_sale-ending__rmaYv","spinner":"packs_spinner__JSGKz"};